import { GridCellProps } from "@progress/kendo-react-grid";

export default function GarageCell(props: GridCellProps) {
    return <td>{props.dataItem.garage ? "Oui" : ""}</td>;
}